import {
  Add_CancelReasons,
  Delete_CancelReasons,
  Get_All_CancelReasons,
  Get_Error,
  Get_One_CancelReasons,
  Update_One_CancelReasons,
} from '../Types';

const intial = {
  Cancelreason: [],
  Updatecancelreason: [],
  loading: true,
};

const Cancelreason_Reducer = (state = intial, action) => {
  switch (action.type) {
    case Add_CancelReasons:
      return {
        ...state,
        Cancelreason: action.payload,
        loading: false,
      };
    case Get_All_CancelReasons:
      return {
        ...state,
        Cancelreason: action.payload,
        loading: false,
      };
    case Delete_CancelReasons:
      return {
        ...state,
        Cancelreason: action.payload,
        loading: false,
      };
    case Get_One_CancelReasons:
      return {
        ...state,
        Cancelreason: action.payload,
        loading: false,
      };
    case Update_One_CancelReasons:
      return {
        ...state,
        Updatecancelreason: action.payload,
        loading: false,
      };

    case Get_Error:
      return {
        loading: true,
        Area: action.payload,
      };
    default:
      return state;
  }
};

export default Cancelreason_Reducer;
